// extracted by mini-css-extract-plugin
module.exports = {"input":"Query_input__25AQX","select":"Query_select__3HnC9","space":"Query_space__2IBjn","selects":"Query_selects__2FR8Z","formQueryPopover":"Query_formQueryPopover__3oRhe"};